import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ButtonVariant, DropdownOption, DropdownOptionDefault, DropdownOptionGroup, DropdownOptionIcon, DropdownOptionType, DropdownSelectionType, IconName, PopoverPosition } from '@yupma/ui-kit';

@Component({
  selector: 'app-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrl: './checkbox-input.component.scss'
})
export class CheckboxInputComponent implements OnInit, OnChanges {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() value: string = '';
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = false;
  @Input() error: boolean = false;
  @Input() disabled: boolean = false;
  @Input() inlineInfo: string = '';
  @Input() errorText: string = 'This field is required.';
  @Input() showLabel: boolean = true;
  @Input() hideEmptyOption: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  iconNames = IconName;
  buttonVariants = ButtonVariant;

  dropdownOptions: DropdownOptionGroup[] = [];
  isDropdownOpen: boolean = false;
  popoverPositions = PopoverPosition;
  dropdownSelectionTypes = DropdownSelectionType;
  selectedOptionLabel: string = '';


  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes['value']) {
      this.setSelectedOption()
    }

  }

  ngOnInit() {
    this.createDropdowns();
    this.setSelectedOption()
  }

  private createDropdowns() {
    let empty = new DropdownOptionDefault(DropdownOptionType.DEFAULT, "", "");
    let yes = new DropdownOptionDefault(DropdownOptionType.DEFAULT, "Yes", "true");
    let no = new DropdownOptionDefault(DropdownOptionType.DEFAULT, "No", "false");
    let dropdownGroup = new DropdownOptionGroup('', [empty, yes, no]);
    if (this.hideEmptyOption) {
      dropdownGroup = new DropdownOptionGroup('', [yes, no]);
    }
    this.dropdownOptions = [dropdownGroup];
  }

  toggleDropdown(state: boolean) {
    this.isDropdownOpen = state;
  }

  selectedOption(option: DropdownOption) {
    this.value = option.value;
    // this.selectedOptionLabel = option.label;
    this.valueChange.emit(this.value);
    this.setSelectedOption()
  }

  setSelectedOption() {
    this.dropdownOptions.forEach(group => {
      group.options.forEach(option => {
        option.selected = (option.value === this.value);
        if (option.value === this.value) {
          this.selectedOptionLabel = option.label;
        }
      });
    });
  }
}
